import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-tag",
  "use": "ico-tag-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"ico-tag\">\n  <path id=\"ico-tag_Path_1539\" data-name=\"Path 1539\" d=\"M24,34.728v8.2a3.512,3.512,0,0,1-1.026,2.485l-9.656,9.656a3.51,3.51,0,0,1-4.965,0L1.029,47.747a3.51,3.51,0,0,1,0-4.965l9.656-9.656A3.512,3.512,0,0,1,13.17,32.1h8.2A2.626,2.626,0,0,1,24,34.728Zm-6.145,5.267A1.756,1.756,0,1,0,16.1,38.239,1.754,1.754,0,0,0,17.855,39.994Z\" transform=\"translate(0 -32.1)\" fill=\"#87baea\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol